import { z } from "zod";
export const PLATFORM_DAILY_VISITOR_METRIC_NAME = "platform_daily_unique_visitor";
export const PlatformDailyVisitorMetricRequestSchema = z.strictObject({
    metricName: z.literal(PLATFORM_DAILY_VISITOR_METRIC_NAME),
    utcDay: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, "utcDay must be a YYYY-MM-DD UTC day key"),
});
